import { render, staticRenderFns } from "./DataSourcesAndAnnotations.vue?vue&type=template&id=5138a00a"
import script from "./DataSourcesAndAnnotations.vue?vue&type=script&lang=js"
export * from "./DataSourcesAndAnnotations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports